import React from 'react'

import NoticeList from '@components/pages/important-notices/NoticeList'
import notices from '@utils/notices'

function ImportantNotices() {
  return (
    <div className="flex-grow max-w-4xl px-4 py-10 m-auto">
      <div className="mb-10 text-center" data-cy="important-notice-logo">
        <h1 className="text-4xl font-bold">Important Notices</h1>
      </div>
      <NoticeList notices={notices} />
    </div>
  )
}

export default ImportantNotices
